import { jsxs as x } from "react/jsx-runtime";
import { forwardRef as z, useMemo as y, cloneElement as N } from "react";
import { e as S } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as d } from "./tw-cn-mXgPecoF.mjs";
import { c as m } from "./index-BpNK5r1N.mjs";
const k = m(
  [
    "inline-flex items-center justify-center no-underline select-none appearance-none",
    "typography-body-14-bold select-none",
    "aria-disabled:pointer-events-none aria-disabled:cursor-not-allowed"
  ],
  {
    variants: {
      buttonType: {
        square: "rounded-12 aspect-square",
        capsule: "!rounded-capsule py-4 px-16 "
      },
      theme: {
        // coumpoundVariants에서 사용
        outlined: "",
        filled: ""
      },
      size: {
        large: "min-h-48 gap-4 rounded-16",
        medium: "min-h-44 gap-4",
        small: "min-h-40 gap-2",
        xsmall: "min-h-36 gap-2"
      },
      pcSize: {
        large: "pc:min-h-48 gap-4 pc:rounded-16",
        medium: "pc:min-h-44 gap-4",
        small: "pc:min-h-40 gap-2",
        xsmall: "pc:min-h-36 gap-2"
      }
    },
    compoundVariants: [
      {
        buttonType: "square",
        theme: "outlined",
        className: [
          "shadow-2 bg-static-white outline outline-1 outline-opacity-black-10",
          "aria-disabled:bg-fill-neutral-weak3",
          "hover-never:shadow-3 hover-never:bg-fill-neutral-weak active:shadow-3 active:bg-fill-neutral-weak",
          "focus:outline focus:outline-1 focus:outline-opacity-black-10"
          // 클릭 시 outline 없어지는 이슈 해결을 위함
        ]
      },
      {
        buttonType: "capsule",
        theme: "outlined",
        className: [
          "border border-line-neutral-main shadow-3",
          "bg-static-white hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
          "aria-disabled:bg-interaction-neutral-disable-main aria-disabled:text-static-white aria-disabled:border-none",
          "aria-disabled:shadow-2"
        ]
      },
      {
        buttonType: "capsule",
        theme: "filled",
        className: [
          "bg-fill-neutral-main text-static-white shadow-3",
          "hover-never:bg-interaction-neutral-presshover-strong1 active:bg-interaction-neutral-presshover-strong1",
          "aria-disabled:bg-interaction-neutral-disable-main aria-disabled:text-static-white aria-disabled:border-none",
          "aria-disabled:shadow-2"
        ]
      }
    ],
    defaultVariants: {
      buttonType: "square",
      theme: "outlined"
    }
  }
), q = m("", {
  variants: {
    theme: {
      outlined: ["text-text-neutral-main"],
      filled: ["text-static-white"]
    },
    size: {
      large: "size-24",
      medium: "size-24",
      small: "size-20",
      xsmall: "size-20"
    },
    pcSize: {
      large: "pc:size-24",
      medium: "pc:size-24",
      small: "pc:size-20",
      xsmall: "pc:size-20"
    },
    disabled: {
      true: "!text-static-white",
      false: ""
    }
  },
  defaultVariants: {
    disabled: !1
  }
}), B = z(
  ({
    disabled: t = !1,
    buttonType: a = "square",
    theme: s,
    direction: n = "left",
    icon: i,
    text: r,
    size: u,
    className: p,
    children: b,
    ...g
  }, h) => {
    const { type: f = "button", ...v } = g, l = S({
      property: u,
      mobileKey: "size",
      pcKey: "pcSize",
      defaultValue: {
        mobile: "medium",
        pc: "large"
      }
    }), { mobile: e } = l, w = k({ buttonType: a, theme: s, ...l }), o = q({ theme: s, ...l, disabled: t }), c = y(
      () => i ? N(i, {
        // buttonType이 capsule일 때 icon의 크기 조정
        className: d(
          o,
          {
            "size-20": a === "capsule" && (e === "medium" || e === "large"),
            "size-16": a === "capsule" && (e === "small" || e === "xsmall"),
            "pc:size-20": a === "capsule" && (e === "medium" || e === "large"),
            "pc:size-16": a === "capsule" && (e === "small" || e === "xsmall")
          },
          i.props.className
        )
      }) : null,
      [i, o, a, e]
    );
    return /* @__PURE__ */ x(
      "button",
      {
        "aria-disabled": t,
        className: d(
          w,
          {
            "!rounded-6": a === "square" && (e === "small" || e === "xsmall")
          },
          p
        ),
        disabled: t,
        ref: h,
        tabIndex: t ? -1 : 0,
        type: f,
        ...v,
        children: [
          n === "left" && c,
          r || b || null,
          n === "right" && c
        ]
      }
    );
  }
);
B.displayName = "NDS.FloatingButton";
export {
  B as F
};
